import _regeneratorRuntime from "D:\\projects\\xena\\node_modules\\@babel\\runtime-corejs2/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:\\projects\\xena\\node_modules\\@babel\\runtime-corejs2/helpers/asyncToGenerator";

/*
import * as Sentry from '@sentry/browser'
import * as Integrations from '@sentry/integrations'

export default async ({ Vue }) => {
    if (process.env.PROD) {
        var pjson = require('../../package.json')
        let options = {
            release: 'friends@' + pjson.version,
            dsn: 'https://e9afb7a7ec7f402cacc5d78f6b6edf59@o280731.ingest.sentry.io/5395582',
            integrations: [new Integrations.Vue({ Vue, attachProps: true })],
            ignoreErrors: ['ResizeObserver loop limit exceeded']
        }
        Sentry.init(options)
    }
}
*/
import * as Sentry from '@sentry/vue';
import { Integrations } from '@sentry/tracing';
import SentryRRWeb from '@sentry/rrweb';
export default
/*#__PURE__*/
(function () {
  var _ref2 = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(_ref) {
    var Vue, pjson;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            Vue = _ref.Vue;

            if (process.env.PROD) {
              pjson = require("../../package.json");
              Sentry.init({
                Vue: Vue,
                release: 'friends@' + pjson.version,
                environment: 'test',
                logErrors: true,
                dsn: 'https://e9afb7a7ec7f402cacc5d78f6b6edf59@o280731.ingest.sentry.io/5395582',
                integrations: [new Integrations.BrowserTracing(), new SentryRRWeb({// ...options
                })],
                // We recommend adjusting this value in production, or using tracesSampler
                // for finer control
                tracesSampleRate: 1.0
              });
              Sentry.setTag('rrweb.active', 'yes');
            }

          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x) {
    return _ref2.apply(this, arguments);
  };
})();